/** @jsx React.createElement */
import React, { useState } from 'react';

const SidebarContext = React.createContext();

export const useSidebar = () => {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};

/** Comme useSidebar, mais retourne null hors provider (pages employé hors Secura Web). */
export const useSidebarOptional = () => React.useContext(SidebarContext) || null;

export const SidebarProvider = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const collapseSidebar = () => {
    setIsCollapsed(true);
  };

  const expandSidebar = () => {
    setIsCollapsed(false);
  };

  const openSidebar = () => {
    setIsOpen(true);
  };

  const closeSidebar = () => {
    setIsOpen(false);
  };

  const toggleSidebarOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <SidebarContext.Provider value={{
      isCollapsed,
      isOpen,
      toggleSidebar,
      collapseSidebar,
      expandSidebar,
      openSidebar,
      closeSidebar,
      toggleSidebarOpen
    }}>
      {children}
    </SidebarContext.Provider>
  );
};




